// import aktivu modules here!
import { lazy, React } from 'react';

const AppSolutionRef = lazy(() =>
  import('../core/app-solution-ref/AppSolutionRef')
);

const AppSetting = lazy(() =>
  import('../core/app-setting/AppSetting')
);
const CSM = lazy(() => import('../core/csm/Csm'));
const Department = lazy(() =>
  import('../core/department/Department')
);
const Facility = lazy(() => import('../core/facility/Facility'));
const FacilityCategory = lazy(() =>
  import('../core/facility-category/FacilityCategory')
);
const FacilityAsset = lazy(() =>
  import('../core/facility-asset/FacilityAsset')
);
const OrgCategory = lazy(() =>
  import('../core/org-category/OrgCategory')
);
const OrgUser = lazy(() => import('../core/org-user/OrgUser'));
const OrgRole = lazy(() => import('../core/org-role/OrgRole'));
const Organization = lazy(() =>
  import('../core/organization/Organization')
);
const PycubeProduct = lazy(() =>
  import('../core/pycube-product/PycubeProduct')
);
const PycubeProductType = lazy(() =>
  import('../core/pycube-product-type/PycubeProductType')
);
const UserAudit = lazy(() => import('../core/user-audit/UserAudit'));
const Vendor = lazy(() => import('../core/vendor/Vendor'));
const Product = lazy(() => import('../core/product/Product'));
const Dashboard = lazy(() => import('../dashboard/Dashboard'));
const DynamicIcon = lazy(() => import('../shared/DynamicIcon'));
const Recall = lazy(() => import('../core/recall/Recall'));
const AssetGroup = lazy(() =>
  import('../core/asset-group/AssetGroup')
);
const MaintenanceLog = lazy(() =>
  import('../core/maintenance-log/MaintenanceLog')
);
const UserList = lazy(() => import('../core/user-asset/UserAsset'));
const Ticket = lazy(() => import('../core/ticket/Ticket'));
const OrgGroup = lazy(() => import('../core/org-group/OrgGroup'));
const Incident = lazy(() => import('../core/incident/Incident'));
const Contact = lazy(() => import('../core/contact/Contact'));
const Building = lazy(() => import('../core/building/Building'));
const Floor = lazy(() => import('../core/floor/Floor'));
const Zone = lazy(() => import('../core/zone/Zone'));
const DeviceKey = lazy(() => import('../core/device-key/DeviceKey'));
const ProfileSettings = lazy(() =>
  import('../core/profile-settings/ProfileSettings')
);
const ChangePassword = lazy(() =>
  import('../core/profile-settings/ChangePassword')
);
const LaundryLossPreventionLog = lazy(() =>
  import(
    '../core/laundry-loss-prevention-log/LaundryLossPreventionLog'
  )
);

export const Routes = [
  {
    type: 'item',
    path: 'dashboard',
    name: 'Dashboard',
    isActive: true,
    icon: <DynamicIcon iconName={'Insights'} />,
    main: () => <Dashboard />,
  },
  {
    type: 'group',
    path: 'app',
    name: 'Pycube Admin',
    children: [
      {
        type: 'item',
        path: 'solutions',
        name: 'App Solutions',
        isActive: true,
        icon: <DynamicIcon iconName={'ViewModule'} />,
        main: () => <AppSolutionRef />,
      },
      {
        type: 'item',
        path: 'settings',
        name: 'App Settings',
        isActive: false,
        icon: <DynamicIcon iconName={'SettingsApplications'} />,
        main: () => <AppSetting />,
      },
      {
        type: 'item',
        path: 'audit',
        name: 'Audit Logs',
        isActive: true,
        icon: <DynamicIcon iconName={'Security'} />,
        main: () => <UserAudit />,
      },
      {
        type: 'item',
        path: 'csm',
        name: 'Pycube Users',
        isActive: true,
        icon: <DynamicIcon iconName={'ManageAccounts'} />,
        main: () => <CSM />,
      },
      {
        type: 'item',
        path: 'hardware',
        name: 'Hardware',
        isActive: true,
        icon: <DynamicIcon iconName={'Handyman'} />,
        main: () => <PycubeProduct />,
      },
      {
        type: 'item',
        path: 'hardwaretype',
        name: 'Hardware Type',
        isActive: true,
        icon: <DynamicIcon iconName={'Hardware'} />,
        main: () => <PycubeProductType />,
      },
      {
        type: 'item',
        path: 'setup',
        name: 'Org Setup',
        isActive: true,
        icon: <DynamicIcon iconName={'PermDataSetting'} />,
        main: () => <Organization />,
      },
    ],
  },
  {
    type: 'group',
    path: 'app',
    name: 'Solution',
    children: [
      {
        type: 'item',
        path: 'lists',
        name: 'Asset Locator',
        isActive: true,
        icon: <DynamicIcon iconName={'List'} />,
        main: () => <UserList />,
      },
      {
        type: 'item',
        path: 'maintenancelogs',
        name: 'Asset PM',
        isActive: true,
        icon: <DynamicIcon iconName={'Construction'} />,
        main: () => <MaintenanceLog />,
      },
      {
        type: 'item',
        path: 'laundrylosspreventionlogs',
        name: 'LLP',
        isActive: true,
        icon: <DynamicIcon iconName={'DryCleaning'} />,
        main: () => <LaundryLossPreventionLog />,
      },
    ],
  },
  {
    type: 'group',
    path: 'app',
    name: 'Assets',
    children: [
      {
        type: 'item',
        path: 'categories',
        name: 'Org Categories',
        isActive: true,
        icon: <DynamicIcon iconName={'Category'} />,
        main: () => <OrgCategory />,
      },
      {
        type: 'item',
        path: 'facilitycategory',
        name: 'Facility Categories',
        isActive: true,
        icon: <DynamicIcon iconName={'Category'} />,
        main: () => <FacilityCategory />,
      },
      {
        type: 'item',
        path: 'products',
        name: 'Products',
        isActive: true,
        icon: <DynamicIcon iconName={'Inventory'} />,
        main: () => <Product />,
      },
      {
        type: 'item',
        path: 'assets',
        name: 'Assets',
        isActive: true,
        icon: <DynamicIcon iconName={'QrCode2'} />,
        main: () => <FacilityAsset />,
      },
      {
        type: 'item',
        path: 'assetgroups',
        name: 'Asset Groups',
        isActive: true,
        icon: <DynamicIcon iconName={'Workspaces'} />,
        main: () => <AssetGroup />,
      },
    ],
  },
  {
    type: 'group',
    path: 'app',
    name: 'Facility',
    children: [
      {
        type: 'item',
        path: 'facilities',
        name: 'Facilities',
        isActive: true,
        icon: <DynamicIcon iconName={'LocalHospital'} />,
        main: () => <Facility />,
      },
      {
        type: 'item',
        path: 'departments',
        name: 'Departments',
        isActive: true,
        icon: <DynamicIcon iconName={'Domain'} />,
        main: () => <Department />,
      },
      {
        type: 'item',
        path: 'buildings',
        name: 'Buildings',
        isActive: true,
        icon: <DynamicIcon iconName={'CorporateFare'} />,
        main: () => <Building />,
      },
      {
        type: 'item',
        path: 'floors',
        name: 'Floors',
        isActive: true,
        icon: <DynamicIcon iconName={'RoomPreferences'} />,
        main: () => <Floor />,
      },
      {
        type: 'item',
        path: 'zones',
        name: 'Zones',
        isActive: true,
        icon: <DynamicIcon iconName={'HomeWork'} />,
        main: () => <Zone />,
      },
    ],
  },
  {
    type: 'group',
    path: 'app',
    name: 'Tickets',
    children: [
      {
        type: 'item',
        path: 'tickets',
        name: 'Tickets',
        isActive: false,
        icon: <DynamicIcon iconName={'BugReport'} />,
        main: () => <Ticket />,
      },
      {
        type: 'item',
        path: 'incidents',
        name: 'Incidents',
        isActive: false,
        icon: <DynamicIcon iconName={'AppsOutage'} />,
        main: () => <Incident />,
      },
      {
        type: 'item',
        path: 'recalls',
        name: 'Recalls',
        isActive: false,
        icon: <DynamicIcon iconName={'Repartition'} />,
        main: () => <Recall />,
      },
    ],
  },
  {
    type: 'group',
    path: 'admin',
    name: 'Users & Groups',
    children: [
      {
        type: 'item',
        path: 'users',
        name: 'Users',
        isActive: true,
        icon: <DynamicIcon iconName={'People'} />,
        main: () => <OrgUser />,
      },
      {
        type: 'item',
        path: 'roles',
        name: 'Roles',
        isActive: true,
        icon: <DynamicIcon iconName={'VerifiedUser'} />,
        main: () => <OrgRole />,
      },
      {
        type: 'item',
        path: 'orggroups',
        name: 'Org Groups',
        isActive: true,
        icon: <DynamicIcon iconName={'GroupWork'} />,
        main: () => <OrgGroup />,
      },
      {
        type: 'item',
        path: 'contacts',
        name: 'Contacts',
        isActive: true,
        icon: <DynamicIcon iconName={'Person'} />,
        main: () => <Contact />,
      },
      {
        type: 'item',
        path: 'vendors',
        name: 'Vendors',
        isActive: true,
        icon: <DynamicIcon iconName={'Engineering'} />,
        main: () => <Vendor />,
      },
    ],
  },
];

export const profileMenu = [
  {
    type: 'group',
    path: 'profileMenu',
    name: 'profile',
    children: [
      {
        type: 'item',
        path: 'profilesettings',
        name: 'Profile Settings',
        main: () => <ProfileSettings />,
      },
      {
        type: 'item',
        path: 'changepassword',
        name: 'Change Password',
        main: () => <ChangePassword />,
      },
      {
        type: 'item',
        path: 'devicekey',
        name: 'Device Key',
        main: () => <DeviceKey />,
      },
    ],
  },
];
